import { LOCALE } from '@/utils'
// import { getLocaleCountry } from '@dy/commons/utils'


// const NEXT_PUBLIC_LOCALE = process.env.NEXT_PUBLIC_LOCALE
// const localeCountry = getLocaleCountry(NEXT_PUBLIC_LOCALE)
// const LOCALE = localeCountry.split('-')[0]
// const REGION = localeCountry.split('-')[1]
// const DY_API_URL = `${process.env.DY_API}/${REGION}/${LOCALE}`
const DY_API_URL = `${process.env.DY_API}`
const API_SUPPORTED_LANGUAGES = ['es', 'en', 'it', 'fr']
/**
 * Sometimes frontend and backend does not support the same amount of languages
**/
const getLang = (lang) => API_SUPPORTED_LANGUAGES.includes(lang) ? lang : LOCALE

export const getSearchParams = query => {
  if (!query?.searchParams || typeof query?.searchParams !== 'object') return ''
  let searchParams = '?'

  Object.keys(query.searchParams).forEach((key) => {
    const value = query.searchParams[key]
    if (Array.isArray(value)) {
      searchParams += `${key}=${value.join(',')}&`
    } else if (typeof value === 'string' && value.length > 0) {
      searchParams += `${key}=${value}&`
    }
  })

  if (searchParams.length === 1) return ''
  return searchParams
}

export const endpoints = {
  'get-layout': (query) => `${DY_API_URL}/${getLang(query.lang)}/layout.json`,
  // PAGES
  'get-homepage': (query) => `${DY_API_URL}/${getLang(query.lang)}/pages/home.json`,
  'get-homepage-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/pages/home/seo`,
  'get-downloads': (query) => `${DY_API_URL}/${getLang(query.lang)}/pages/downloads`,
  'get-content-pages-slugs': (query) => `${DY_API_URL}/${getLang(query.lang)}/pages`,
  'get-content-page': (query) => `${DY_API_URL}/${getLang(query.lang)}/pages/${query.content_slug}`,
  'get-content-page-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/pages/${query.slug}/seo`,
  // PRODUCTS
  'get-product-categories': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/product.json`,
  // 'get-product-category': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/product/${query.category_slug}${getSearchParams(query)}`, // USA Not included
  'get-product-category': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/product/${query.category_slug}.json`,
  'get-product-category-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/product/${query.category_slug}/seo`,
  'get-products': (query) => `${DY_API_URL}/${getLang(query.lang)}/products.json}`,
  'get-product-detail': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/${query.slug}.json`,
  'get-product-detail-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/${query.slug}/seo`,
  'get-product-detail-slider-images': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/${query.slug}/media?colors=${query.ids}`,
  'get-product-configurator': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/${query.slug}/variant?options=${query.ids}`,
  'get-product-configurator-colors': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/${query.slug}/media?colors=${query.ids}`,
  'get-usa-product-category': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/product/all/US.json`,
  'get-usa-products': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/usa.json`,
  'get-usa-product-category-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/product/all/US/seo`,
  'get-usa-product-detail': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/usa/${query.slug}.json`,
  'get-usa-product-detail-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/usa/${query.slug}/seo`,
  'get-usa-product-detail-slider-images': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/usa/${query.slug}/media?colors=${query.ids}`,
  'get-usa-product-configurator': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/usa/${query.slug}/variant?options=${query.ids}`,
  'get-usa-product-configurator-colors': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/usa/${query.slug}/media?colors=${query.ids}`,
  // PROJECTS
  'get-project-categories': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/project.json`,
  'get-project-category': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/project/${query.category_slug}.json`,
  'get-project-category-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/categories/project/${query.category_slug}/seo`,
  'get-projects': (query) => `${DY_API_URL}/${getLang(query.lang)}/projects.json`,
  'get-project-detail': (query) => `${DY_API_URL}/${getLang(query.lang)}/projects/${query.slug}.json`,
  'get-project-detail-seo': (query) => `${DY_API_URL}/${getLang(query.lang)}/projects/${query.slug}/seo`,
  // SEARCH
  'search': (query) => `${DY_API_URL}/${getLang(query.lang)}/search${getSearchParams(query)}`,
  'search-products': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/search${getSearchParams(query)}`,
  // STORES
  'get-stores-online': (query) => `${DY_API_URL}/${getLang(query.lang)}/stores/online`,
  'get-stores-distributors': (query) => `${DY_API_URL}/${getLang(query.lang)}/stores/distributor`,
  // POST SUBSCRIBERS
  'contact': (query) => `${DY_API_URL}/${getLang(query.lang)}/subscribers/contact`,
  'newsletter': (query) => `${DY_API_URL}/${getLang(query.lang)}/subscribers/newsletter`,
  //coutnries
  'get-countries': () => '/public/countries.json',
  'get-pdf-spec-sheet-url': (query) => `${DY_API_URL}/${getLang(query.lang)}/products/configurator_download?code=${query.slug}`,
}
